import React from 'react';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';

import { SaveButton } from '../save-button';
import { messages } from '../messages';
import style from './style.module.less';

export const ShipFromModalFooter = ({ onClose }) => {
  return (
    <ModalFooter className={style['modal-footer']}>
      <Button onClick={onClose} theme='tertiary'>
        <FormattedMessage {...messages.cancel} />
      </Button>
      <SaveButton />
    </ModalFooter>
  );
};
